import { useState, useContext, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { swalPopUp } from "../../utils/swal";
import { UserContext } from "../../context/userContext";
import { logout } from "../../auth/authApi";
import { findUser } from "../../utils/apiDb/apiDbAcions";
import "../../styles/navigation/Dropdown.css";

const Dropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const thisLocation = useLocation();
  const navigate = useNavigate();
  const { userData, updateUserData } = useContext(UserContext);
  const timerRef = useRef(null);
  const dropdownRef = useRef(null);

  const [profile, setProfile] = useState({
    name: userData.name || "Usuario",
    avatar: "/images/user.png",
  });

  useEffect(() => {
    if (userData.email) {
      const loadProfile = async () => {
        const response = await findUser("email", userData.email, "name avatar.url");
        if (response.success && response.userData) {
          setProfile({
            name: response.userData.name || userData.name || "Usuario",
            avatar: response.userData.avatar?.url || "/images/user.png",
          });
        }
      };
      loadProfile();
    }
  }, [userData]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    
    // Clear any existing timer
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    
    // Set new timer if opening the dropdown
    if (!isOpen) {
      timerRef.current = setTimeout(() => {
        setIsOpen(false);
        timerRef.current = null;
      }, 5000);
    }
  };

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        if (timerRef.current) clearTimeout(timerRef.current);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Cleanup timer on component unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const exit = async (e) => {
    e.preventDefault();
    try {
      await logout();
      updateUserData({ email: "", name: "", isLogged: false, role: "user" });
      swalPopUp("LogOut", "Cierre de sesión exitoso", "success");
      navigate("/");
    } catch (error) {
      swalPopUp("Error", error.message, "error");
    }
  };

  const toDash = (e) => {
    e.preventDefault();
    localStorage.setItem("previousPathToDash", thisLocation.pathname);
    navigate("/Dashboard");
    setIsOpen(false);
  };

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <button 
        className="dropdown-button" 
        onClick={toggleDropdown}
      >
        <img src={profile.avatar} alt="User" className="dropdown-trigger-avatar" />
        <span className="dropdown-trigger-text">Perfil</span>
        <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} dropdown-chevron`} />
      </button>

      {isOpen && (
        <div className="dropdown-content saas-dropdown">
          <div className="dropdown-header">
            <img src={profile.avatar} alt="Avatar" className="dropdown-header-avatar" />
            <div className="dropdown-header-info">
              <span className="dropdown-name">{profile.name}</span>
              <span className="dropdown-email">{userData.email}</span>
            </div>
          </div>
          
          <div className="dropdown-divider"></div>

          <div className="dropdown-body">
            <Link className="link-dropdown" to="/Perfil" onClick={() => setIsOpen(false)}>
              <i className="fas fa-user-circle" /> Mi Perfil
            </Link>
            <Link className="link-dropdown" to="/MisEmpresas" onClick={() => setIsOpen(false)}>
              <i className="fa-solid fa-store" /> Mis Negocios
            </Link>
            <Link className="link-dropdown" to="/Favoritos" onClick={() => setIsOpen(false)}>
              <i className="fas fa-heart" /> Favoritos
            </Link>
            <Link className="link-dropdown" to="/Dashboard" onClick={toDash}>
              <i className="fas fa-tachometer-alt" /> Dashboard
            </Link>
          </div>

          <div className="dropdown-divider"></div>

          <div className="dropdown-footer">
            <Link className="link-dropdown dropdown-logout" to="/" onClick={exit}>
              <i className="fas fa-sign-out-alt" /> Cerrar Sesión
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
